// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * PinnedEventsBanner styles
 * A clickable banner that appears below the top bar when pinned messages exist
 * Follows patterns from TopBar.css and PinnedMessagesPanel.css
 */

/* Main banner container */
.pinned-events-banner {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  background-color: #f8f8f8;
  border-bottom: 1px solid rgb(220, 220, 220);
  cursor: pointer;
  gap: 8px;
  min-height: 40px;
  flex-shrink: 0;
}

.pinned-events-banner:hover {
  background-color: #f0f0f0;
}

/* Navigation buttons */
.pinned-banner-nav {
  background: none;
  border: none;
  padding: 4px;
  cursor: pointer;
  color: rgb(100, 100, 100);
  display: flex;
  align-items: center;
  font-size: 18px;
}

.pinned-banner-nav:hover {
  color: rgb(50, 50, 50);
}

/* Pin bar icon */
.pinned-banner-icon {
  width: 14px;
  height: 14px;
  flex-shrink: 0;
}

/* Content area */
.pinned-banner-content {
  flex: 1;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Roboto, sans-serif;
}

/* Sender name */
.pinned-banner-sender {
  font-weight: 500;
  margin-right: 4px;
  color: rgb(50, 50, 50);
}

/* Message text preview */
.pinned-banner-text {
  color: rgb(100, 100, 100);
}

/* Pin counter (1/3 format) */
.pinned-banner-counter {
  color: rgb(100, 100, 100);
  font-size: 12px;
  font-family: Roboto, sans-serif;
  white-space: nowrap;
  margin-left: 4px;
}

/* Disabled state for navigation buttons */
.pinned-banner-nav:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Screen reader only - visually hidden but accessible */
.pinned-events-banner .sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

/* Emote message styling in banner */
.pinned-banner-emote {
  font-style: italic;
}

/* Focus styles for keyboard navigation */
.pinned-events-banner:focus {
  outline: 2px solid rgb(222, 72, 88);
  outline-offset: -2px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Page/Conversations/ChatView/PinnedEventsBanner.css"],"names":[],"mappings":"AAAA;;;;EAIE;;AAEF,0BAA0B;AAC1B;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,2CAA2C;EAC3C,eAAe;EACf,QAAQ;EACR,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,OAAO;EACP,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,+BAA+B;AACjC;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA,yBAAyB;AACzB;EACE,yBAAyB;AAC3B;;AAEA,6BAA6B;AAC7B;EACE,yBAAyB;EACzB,eAAe;EACf,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,0CAA0C;AAC1C;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,wDAAwD;AACxD;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA,oCAAoC;AACpC;EACE,kBAAkB;AACpB;;AAEA,yCAAyC;AACzC;EACE,mCAAmC;EACnC,oBAAoB;AACtB","sourcesContent":["/**\n * PinnedEventsBanner styles\n * A clickable banner that appears below the top bar when pinned messages exist\n * Follows patterns from TopBar.css and PinnedMessagesPanel.css\n */\n\n/* Main banner container */\n.pinned-events-banner {\n  display: flex;\n  align-items: center;\n  padding: 8px 12px;\n  background-color: #f8f8f8;\n  border-bottom: 1px solid rgb(220, 220, 220);\n  cursor: pointer;\n  gap: 8px;\n  min-height: 40px;\n  flex-shrink: 0;\n}\n\n.pinned-events-banner:hover {\n  background-color: #f0f0f0;\n}\n\n/* Navigation buttons */\n.pinned-banner-nav {\n  background: none;\n  border: none;\n  padding: 4px;\n  cursor: pointer;\n  color: rgb(100, 100, 100);\n  display: flex;\n  align-items: center;\n  font-size: 18px;\n}\n\n.pinned-banner-nav:hover {\n  color: rgb(50, 50, 50);\n}\n\n/* Pin bar icon */\n.pinned-banner-icon {\n  width: 14px;\n  height: 14px;\n  flex-shrink: 0;\n}\n\n/* Content area */\n.pinned-banner-content {\n  flex: 1;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  font-size: 14px;\n  font-family: Roboto, sans-serif;\n}\n\n/* Sender name */\n.pinned-banner-sender {\n  font-weight: 500;\n  margin-right: 4px;\n  color: rgb(50, 50, 50);\n}\n\n/* Message text preview */\n.pinned-banner-text {\n  color: rgb(100, 100, 100);\n}\n\n/* Pin counter (1/3 format) */\n.pinned-banner-counter {\n  color: rgb(100, 100, 100);\n  font-size: 12px;\n  font-family: Roboto, sans-serif;\n  white-space: nowrap;\n  margin-left: 4px;\n}\n\n/* Disabled state for navigation buttons */\n.pinned-banner-nav:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Screen reader only - visually hidden but accessible */\n.pinned-events-banner .sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n/* Emote message styling in banner */\n.pinned-banner-emote {\n  font-style: italic;\n}\n\n/* Focus styles for keyboard navigation */\n.pinned-events-banner:focus {\n  outline: 2px solid rgb(222, 72, 88);\n  outline-offset: -2px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
